import { EnrolState } from 'enum'
import { IUserModel, userInitialState } from './user.model'
import { ICourseModel } from './course.model'
import { ISynchronousCourseEnrol } from './synchronousCourseEnrol.model'

export interface SynchronousCourseProperties {
  minimumGrade?: number
  maximumGrade?: number
}

export interface IEnrolModel {
  id?: number
  stateAdmin: EnrolState
  note: string
  userId: number
  courseId: number
  user: IUserModel
  course: ICourseModel
  createdAt?: string
  answerAdmin?: string
  finishDate?: string
  adminApproved?: IUserModel
  data?: any
  area?: any
  synchronousCourseEnrol?: ISynchronousCourseEnrol
  manuallyAssigned?: boolean
  imported?: boolean
}

export const enrolInitialState: IEnrolModel = {
  stateAdmin: 0,
  note: '',
  userId: 0,
  courseId: 0,
  user: userInitialState as IUserModel,
  course: {} as ICourseModel,
}
